import { mapGetters } from "vuex"

export default {
    methods: {
        getProfileFromProvider(providerId, {profile_map, profile}) {
            if(profile_map) {
                const providerProfile = profile_map.find((providerProfile) => providerProfile.includes(providerId))
                if(providerProfile)
                    return '(' + this.getContentKey('profile', providerProfile.split(':')[1], 'title') + ')'
            }
            else
                return '(' + this.getContentKey('profile', profile[0], 'title') + ')'
        }
    },
    computed: {
        ...mapGetters('content', [
            'getContentKey'
        ]),
    }
}